import React, { Fragment, useEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next"

import { isInPosDevice } from "utils"
import { Button } from "components"
import SssuUpdateModal from "./SssuUpdateModal"
import classes from "./index.module.scss"

const SsSiteUpdater = () => {
  const [t] = useTranslation()

  const [sending, setSending] = useState(false)
  const [showHaveUpdateModal, setShowHaveUpdateModal] = useState(false)

  const unmount = useRef(false)
  const timeout = useRef(false)

  const removeCaches = async () => {
    const keys = await caches.keys()

    const cachesNeededToBeRemoved = []

    keys.forEach((key) => {
      if (key.includes("workbox")) {
        return cachesNeededToBeRemoved.push(key)
      }

      if (key === "htmls") {
        return cachesNeededToBeRemoved.push(key)
      }
    })

    for (const key of cachesNeededToBeRemoved) {
      await caches.delete(key)
    }
  }

  const unregisterServiceWorker = async () => {
    const registrations =
      await navigator.serviceWorker.getRegistrations()

    await registrations[0]?.unregister()
  }

  const handleForceUpdate = async () => {
    setShowHaveUpdateModal(true)

    setSending(true)

    try {
      await unregisterServiceWorker()

      await removeCaches()

      if (unmount.current) return

      timeout.current =
        setTimeout(() => {
          window.location.href = "/"
        }, 3000)
    } catch (err) {
      console.log(err)
    }

    setSending(false)
  }


  useEffect(() => {
    return () => { clearTimeout(timeout.current) }
  }, [])

  if (isInPosDevice()) return null

  return (
    <Fragment>
      <div className={classes["container"]}>
        <Button
          loading={sending}
          color="info"
          onClick={handleForceUpdate}
        >
          {t("بروز_رسانی_سایت")}
        </Button>
      </div>

      <SssuUpdateModal
        showHaveUpdateModal={showHaveUpdateModal}
      />
    </Fragment>
  )
}

export default SsSiteUpdater